import { useMutation, useQueryClient } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  declarationsIdsForUpdate: string[];
  batchId: string;
}

export const useUpdateBatchStatistics = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ declarationsIdsForUpdate, batchId }: HookProps) => {
      await request({
        path: `batches/${batchId}/update-statistics`,
        method: 'POST',
        authenticate: true,
        dataObject: { declarationsIdsForUpdate },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batches'] });
    },
    onError: (error) => {
      showErrorToast(error, 'Error updating statistics for batch!');
    },
  });
};
